module.exports = __webpack_public_path__ + "src/assets/img/rekko.c4c096cd.jpg";